/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.216.0-v202610240058-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

/**
 * A filter for compositing multiple filters
 */
export interface CompositeFilter {
    "filter1"?: models.Filter;
    "filter2"?: models.Filter;
    /**
     * Whether to OR or AND the two filters
     */
    "operation"?: OperationEnum;
}

export const OperationEnum = {
    AND: 'AND',
    OR: 'OR'
} as const;

export type OperationEnum = typeof OperationEnum[keyof typeof OperationEnum];
